import type { Role } from '@death-star/shared';
import { useAuth } from './auth.js';

export function useRole(): { role: Role | null; loading: boolean } {
  const { role, roleLoading, idToken } = useAuth();
  return {
    role,
    // We have a token but role hasn't resolved → still loading.
    loading: idToken !== null && (roleLoading || role === null),
  };
}
